import { render, staticRenderFns } from "./StadiumEntrance.vue?vue&type=template&id=84dd502c"
import script from "./StadiumEntrance.vue?vue&type=script&lang=js"
export * from "./StadiumEntrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports